import React from 'react';

import { StyleSheet, View } from 'react-native';

import { t } from 'state/intl/translations';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

import { AmenityIcon, InnerText } from '../styled';
import type { RestaurantDetailItem } from '../types';

interface AmenityItemsProps {
  items: RestaurantDetailItem[];
}

export const AmenityItems = ({ items }: AmenityItemsProps) => (
  <View style={styles.amenityGrid}>
    {items.map(({ icon, label, testID }) => (
      <View key={label.key} testID={testID} style={styles.amenityItem}>
        <AmenityIcon
          variant={icon}
          size="$5"
          style={styles.detailIcon}
          {...hiddenAccessibilityPlatformProps}
        />
        <InnerText style={styles.detailItemText}>{t(label.key, label.defaultMessage)}</InnerText>
      </View>
    ))}
  </View>
);

const styles = StyleSheet.create({
  amenityGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 12,
    rowGap: 4,
  },
  amenityItem: {
    alignItems: 'center',
    flexDirection: 'row',
    paddingRight: 12,
    width: '50%',
  },
  detailIcon: {
    marginRight: 10,
  },
  detailItemText: {
    flex: 1,
  },
});
